import * as React from 'react';
import styled from 'styled-components';
import { useImageFade } from '../../../utils/hooks/useImageFade';
import useVisibilitySensor from '@rooks/use-visibility-sensor';

type BrokerImageSize = 'small' | 'medium' | 'large';

interface IBrokerImage {
  className?: string;
  url: string;
  size: BrokerImageSize;
}

export const Image: React.FC<IBrokerImage> = React.memo(
  ({ className, url, size = 'large' }) => {
    const imageRef = React.useRef(null);
    const { isVisible } = useVisibilitySensor(imageRef, {
      intervalCheck: false,
      scrollCheck: true,
      resizeCheck: true,
      shouldCheckOnMount: true,
      minTopValue: -100,
      partialVisibility: true,
    });

    const { loaded } = useImageFade({
      url: url,
      visible: isVisible,
    });

    let classes = `${className ? className : ''} ${size ? size : ''}`;

    return (
      <StyledBrokerImageWrapper ref={imageRef} className={classes}>
        <StyledBrokerImage image={url} className={loaded ? 'loaded' : ''} />
      </StyledBrokerImageWrapper>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.url === nextProps.url) {
      return true;
    }
    return false;
  }
);

interface IProps {
  loaded?: boolean;
  url?: string;
}

const StyledBrokerImage = styled.div<any>`
  transition: opacity 0.15s ease-in-out;
  width: 100%;
  height: 100%;
  background: url(${(props) => props.image}) no-repeat;
  background-size: cover;
  background-position: 50% 20%;
  border-radius: 150px;
  opacity: 0;

  &.loaded {
    opacity: 1;
  }
`;

const StyledBrokerImageWrapper = styled.div`
  position: relative;
  border-radius: 150px;
  background-clip: padding-box;
  background: rgb(40, 40, 40);
  overflow: hidden;
  &.large {
    width: 150px;
    height: 150px;
  }
  &.medium {
    width: 105px;
    height: 105px;
  }
  &.small {
    width: 55px;
    height: 55px;
  }

  img {
    position: absolute;
    width: 1;
    height: 1;
    z-index: -1;
    visibility: hidden;
  }
`;
